module.exports = __webpack_public_path__ + "img/chatpilot-long.8df7d5d1.svg";